module.exports = __webpack_public_path__ + "static/media/retirement-object-2-1-1.60fbc205.png";